
import { useEffect, useState } from "react";
import ReactGA from "react-ga4";

import Quest from "../section/mainsite/Quest";
import Seo from "../components/SEO"
import { useFacebookPageView } from "../hook/useFacebookPageView";


function About() {

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/about", title: "About Us page" });
  }, []);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    console.log(windowWidth);
    window.onresize = () => {
      setWindowWidth(window.innerWidth);
    };
  }, []);

  useFacebookPageView();

  return (
  <>
    <Seo
      title="About Us page"
      description="About Us page of F*** It! - the first rehydration drink for sex by Rouse. We’re not selling sugar water with a logo — we’re building a sex-positivity movement that actually matters. People are stressed, disconnected, and tired of pretending. We want to bring back real intimacy — without shame, without pressure. #keepgoing"
      url="https://therouseco.com/about"
      keywords={["Rouse, drink, rehydration, sex, F*** It, about, about us"]}
      uploadDate="2025-07-09"
      includeVideoSchema={false}
    />

    <Quest isSubpage={true} />
  </>
  );
}

export default About;
